import React from 'react';

/**
 * The BidWin bolt mark. Inline so it can inherit `currentColor` (token-driven)
 * and render at any size — used in the nav lockup, the footer, and the scoring
 * showcase's "Run AI deep-score" button. Set the color via a text-* token class
 * on this element or its parent.
 */
export function BwLogoGlyph({ className = '' }: { className?: string }) {
  return (
    <svg viewBox="0 0 24 24" fill="currentColor" className={className} aria-hidden="true">
      <path d="M4 14a1 1 0 0 1-.78-1.63l9.9-10.2a.5.5 0 0 1 .86.46l-1.92 6.02A1 1 0 0 0 13 10h7a1 1 0 0 1 .78 1.63l-9.9 10.2a.5.5 0 0 1-.86-.46l1.92-6.02A1 1 0 0 0 11 14z" />
    </svg>
  );
}
